import { isEmpty } from 'ramda'
import { formatAmountForDisplay, formatDate } from 'src/utils'
import { positionsStatesFiltersOpts } from './constants'
import * as types from './types'

const states = positionsStatesFiltersOpts.map((value) => value.key)

export default {
  [types.POSITIONS_TO_SHOW](state) {
    return state.positions.map((position) => {
      return {
        debtorName: position.debtor_name,
        invoiceTotalSize: position.invoice_total_size,
        formattedInvoiceSize: formatAmountForDisplay(
          position.size,
          position.currency
        ),
        amount: position.amount,
        formattedAmount: formatAmountForDisplay(
          position.amount,
          position.currency
        ),
        maturityDate: position.maturity_date,
        formattedMaturityDate: formatDate(position.maturity_date, 'DD/MM/YYYY'),
        modifiedAt: position.modified_at,
        formattedModifiedAt: position.modified_at
          ? formatDate(position.modified_at, 'DD/MM/YYYY')
          : '-',
        state: position.state,
        isin: position.isin,
        currency: position.currency
      }
    })
  },
  [types.PARAMS_TO_SEND](state) {
    return {
      // pagination
      limit: state.pagination.itemsPerPage,
      offset: (state.pagination.page - 1) * state.pagination.itemsPerPage,
      // filters
      companyId: state.filters.companyId,
      accountId: state.filters.accountId,
      start_date: state.filters.startDate,
      end_date: state.filters.endDate,
      types: isEmpty(state.filters.types)
        ? states.join(',')
        : state.filters.types.join(',')
    }
  }
}
